import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WidgetInstanceContainerModel} from '../../../../../../models/aggregates/cms/widget';
import { ApiVisa, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
@Injectable({providedIn: 'root'})

export class WidgetInstanceService extends BaseApiPublicLoginTemplateService<WidgetInstanceContainerModel, WidgetInstanceContainerModel, WidgetInstanceContainerModel> {

  static readonly WIDGET_INSTANCE_SUB_PATH = 'widget-instances/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'widget-instances';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'widget-instances';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WidgetInstanceService.WIDGET_INSTANCE_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WidgetInstanceService.WIDGET_INSTANCE_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + this.endpoint_path + '/replace-file/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, extGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + extGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
}
